import { render, staticRenderFns } from "./MandateConflictDetail.vue?vue&type=template&id=65b4f5ec&scoped=true&"
import script from "./MandateConflictDetail.vue?vue&type=script&lang=js&"
export * from "./MandateConflictDetail.vue?vue&type=script&lang=js&"
import style0 from "./MandateConflictDetail.vue?vue&type=style&index=0&id=65b4f5ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4f5ec",
  null
  
)

export default component.exports